
<h2 mat-dialog-title>{{ 'COMMON.SELECT-DEPARTMENT' | translate}}</h2>
<div mat-dialog-content>
    
     <mat-form-field class="w-100">
        <mat-label [attr.for]="selectedDepartmentID">{{ 'COMMON.ALL-DEPARTMENTS' | translate}}</mat-label>
        <mat-select [id]="selectedDepartmentID"  placeholder="question.placeholder*" [(ngModel)]="selectedDepartmentID"> 
          <mat-option>{{ 'COMMON.ALL-DEPARTMENTS' | translate}}</mat-option>               
          <mat-option *ngFor="let department of departments" [value]="department.ID">{{department.Name}}</mat-option>
        </mat-select>
      </mat-form-field>
    
    <!-- native element-->
    <!-- <mat-form-field appearance="fill" class="w-100">
      <mat-label>{{ 'COMMON.SELECT-DEPARTMENT' | translate}}</mat-label>
      <select matNativeControl [(ngModel)]="selectedDepartmentID">
        <option>{{ 'COMMON.ALL-DEPARTMENTS' | translate}}</option>
        <option *ngFor="let department of departments" [value]="department.ID">{{department.Name}}</option>
      </select>
    </mat-form-field>
    Selected: {{ selectedDepartmentID }} -->
</div>
  
  
<div mat-dialog-actions align="center">  
    <button mat-raised-button color="accent" fxFlex="1 1 auto"  cdkFocusInitial (click)="onSave($event)">{{'COMMON.SAVE' | translate}}</button>  
    <button mat-raised-button color="primary" fxFlex="1 1 auto"   (click)="onCancel($event)">{{'COMMON.CANCEL' | translate}}</button>
</div>
